import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { deleteAccountBusinessFile } from "../../../../../api/correspondent/CorresspondentApi";
import { DeleteFileType } from "../../../../../types/common/basic";

type Props = {
  setRead: () => void;
};

/**
 * 거래처 파일삭제 훅
 * @param props
 * @returns
 */
const useDeleteAccountBusinessFile = ({ setRead }: Props) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: (data: DeleteFileType) => deleteAccountBusinessFile(data),
    onSuccess: (res) => {
      console.log(res);
      setRead();
      queryClient.invalidateQueries({
        queryKey: ["readAccountBasicInfo"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
  return { mutate };
};

export default useDeleteAccountBusinessFile;
